/**
 * Default research type used throughout the application
 * when no specific research type is provided.
 */
export const DEFAULT_RESEARCH_TYPE = "generative_summarization" as const;

/**
 * Available research types in the system
 */
export const RESEARCH_TYPES = {
  GENERATIVE_SUMMARIZATION: "generative_summarization",
  DUPLICATE_DOCUMENTS: "duplicate_documents",
  SEMANTIC_ONLY: "semantic_only",
} as const;

export type ResearchType = (typeof RESEARCH_TYPES)[keyof typeof RESEARCH_TYPES];
